import { render } from "./templateForm.vue?vue&type=template&id=6f8e14ca&scoped=true"
import script from "./templateForm.vue?vue&type=script&lang=js"
export * from "./templateForm.vue?vue&type=script&lang=js"

import "./templateForm.vue?vue&type=style&index=0&id=6f8e14ca&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8e14ca"]])

export default __exports__